import * as React from "react"
import type { SVGProps } from "react"
const SvgHeading2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 17a1 1 0 0 1-.71-.29A1 1 0 0 1 3 16V8q0-.42.29-.71A1 1 0 0 1 4 7q.42 0 .71.29.3.29.29.71v3h4V8q0-.42.29-.71A1 1 0 0 1 10 7q.42 0 .71.29.3.29.29.71v8q0 .42-.29.71A1 1 0 0 1 10 17a1 1 0 0 1-.71-.29A1 1 0 0 1 9 16v-3H5v3q0 .42-.29.71A1 1 0 0 1 4 17m10 0a1 1 0 0 1-.71-.29A1 1 0 0 1 13 16v-3q0-.83.59-1.41A2 2 0 0 1 15 11h4V9h-5a1 1 0 0 1-.71-.29A1 1 0 0 1 13 8q0-.42.29-.71A1 1 0 0 1 14 7h5q.83 0 1.41.59.6.59.59 1.41v2q0 .83-.59 1.41A2 2 0 0 1 19 13h-4v2h5q.42 0 .71.29.3.29.29.71c-.01.42-.1.52-.29.71A1 1 0 0 1 20 17z" />
  </svg>
)
export default SvgHeading2
